import { UI_UspList } from 'ui/components/3-organisms/UspList/UspList';

type Props = Content.GridCell & {
	content: {
		properties: {
			heading?: string;
			items: {
				content: {
					properties: {
						image: Content.Image;
						title: string;
						description: string;
						link: Content.Link;
					};
				};
			}[];
		};
	};
};

export const UspList = ({ content }: Props) => {
	const items = content?.properties?.items ?? [];

	return (
		<UI_UspList
			heading={content?.properties?.heading}
			items={items.map(({ content }, index) => {
				const { image, title, description, link } = content?.properties ?? {};

				return {
					image: {
						url: image?.url,
						focalPoint: {
							left: image?.focalPoint?.left,
							top: image?.focalPoint?.top,
						},
						extension: image?.properties?.umbracoExtension ?? '',
						altText: image?.properties?.altText ?? '',
					},
					number: index + 1,
					title: title,
					description: description,
					link: {
						url: link?.url,
						target: link?.target,
						name: link?.name,
					},
				};
			})}
		/>
	);
};
